import { createSlice } from "@reduxjs/toolkit";
import { onboardingInitialState, onboardingReducerKey } from "./onboarding.constants";

export const onboardingSlice = createSlice({
  name: onboardingReducerKey,
  initialState: onboardingInitialState,
  reducers: {
    setOnboardingData(state, { payload }) {
      return { ...state, ...payload };
    },
    clearOnboardingData() {
      return onboardingInitialState;
    },
  },
});

export const { setOnboardingData, clearOnboardingData } = onboardingSlice.actions;